/**
 * Mapping von URL-Pattern zu erwarteten Permissions.
 * Wird vom HelpDrawer (Super-Admin-RBAC-Audit) genutzt, um pro Page
 * die relevanten Permissions zu erfragen.
 */
export const PAGE_PERMISSIONS: Record<string, string[]> = {
  '/projects': ['project.read', 'project.create', 'project.update', 'project.delete'],
  '/employees/working-time': ['working_time.read', 'working_time.manage'],
  '/employees/competencies': ['competency.read', 'competency.create'],
  '/employees': ['employee.read', 'employee.create', 'employee.update', 'employee.delete'],
  '/calendar': ['appointment.view_own', 'appointment.view_team', 'appointment.create', 'appointment.manage'],
  '/absences': ['absence.view_own', 'absence.view_team', 'absence.create', 'absence.approve', 'absence.manage'],
  '/leave-requests': ['absence.view_own', 'absence.create', 'absence.approve'],
  '/sick-leave': ['absence.view_own', 'absence.create'],
  '/tickets': ['ticket.read', 'ticket.create', 'ticket.update', 'ticket.delete'],
  '/corporations': ['corporation.read', 'corporation.create', 'corporation.update', 'corporation.delete'],
  '/customers': ['contact.read', 'contact.create', 'contact.update', 'contact.delete'],
  '/organization': ['ou.read', 'ou.create', 'ou.update', 'ou.delete'],
  '/holidays': ['holiday.view', 'holiday.manage', 'holiday.import'],
  '/resources': ['resource.view', 'resource.manage', 'booking.view', 'booking.create', 'booking.manage'],
  '/time-tracking': ['attendance.view_own', 'attendance.create', 'attendance.manage'],
  '/cost-elements': ['cost_element.read', 'cost_element.create'],
  '/bc-exports': ['bc_export.view', 'bc_export.manage'],
  '/reports': ['report.view'],
  '/service-contracts': ['service_contract.read', 'service_contract.create'],
  '/cmdb': ['cmdb.items.read', 'cmdb.items.create', 'cmdb.object_types.read'],
  '/admin': ['admin.settings', 'admin.tenant_config'],
};

/**
 * Liefert für einen pathname die zugeordneten Permissions.
 * Match-Strategie: längster passender Prefix gewinnt.
 */
export function getPermissionsForRoute(pathname: string): string[] {
  let bestMatch: string | null = null;
  for (const prefix of Object.keys(PAGE_PERMISSIONS)) {
    if (pathname === prefix || pathname.startsWith(prefix + '/')) {
      if (bestMatch === null || prefix.length > bestMatch.length) {
        bestMatch = prefix;
      }
    }
  }
  return bestMatch ? PAGE_PERMISSIONS[bestMatch]! : [];
}
